window.Webflow = window.Webflow || [];
window.Webflow.push(() => {
  const orderForm = document.getElementById('ORDERFORM') as HTMLFormElement | null;
  const radioButtons = document.querySelectorAll<HTMLInputElement>('input[name="Versio"]');

  // When user clicks version radio button, displays "Selected" label on top of current selection
  radioButtons.forEach((radioButton: HTMLInputElement) => {
    const parentElement = radioButton.closest('.radio-button-field');
    const labelElement = parentElement?.previousElementSibling as HTMLElement | null;

    radioButton.addEventListener('change', () => {
      // Remove the "cc-selected" class from all parent elements
      document.querySelectorAll('.radio-button-field').forEach((element: Element) => {
        element.classList.remove('cc-selected');
      });

      document.querySelectorAll('.chosen-plan-label-wrapper').forEach((element: Element) => {
        element.classList.remove('cc-selected');
      });

      if (parentElement) {
        radioButton.checked = true;
        parentElement.classList.add('cc-selected');
        labelElement?.classList.add('cc-selected');
      }
    });
  });

  // Get the quantity input and price text elements
  const quantityInput = document.querySelector('[k-el="quantityInput"]') as HTMLInputElement | null;
  const proPriceElement = document.querySelector('[k-el="proPrice"]') as HTMLElement | null;
  const easyPriceElement = document.querySelector('[k-el="easyPrice"]') as HTMLElement | null;

  const radioEasy = document.getElementById('Easy') as HTMLInputElement | null;
  const radioPro = document.getElementById('Pro') as HTMLInputElement | null;
  const proRadioInputDiv = radioPro?.previousElementSibling as HTMLElement | null;
  const easyRadioInputDiv = radioEasy?.previousElementSibling as HTMLElement | null;

  const proParentElement = radioPro?.closest('.radio-button-field') as HTMLElement | null;
  const easyParentElement = radioEasy?.closest('.radio-button-field') as HTMLElement | null;

  const proLabelElement = proParentElement?.previousElementSibling as HTMLElement | null;
  const easyLabelElement = easyParentElement?.previousElementSibling as HTMLElement | null;

  if (radioEasy) {
    radioEasy.checked = true;
  }
  if (radioPro) {
    radioPro.checked = false;
  }
  easyRadioInputDiv?.classList.add('w--redirected-checked');
  proRadioInputDiv?.classList.remove('w--redirected-checked');
  easyParentElement?.classList.add('cc-selected');
  proParentElement?.classList.remove('cc-selected');
  easyLabelElement?.classList.add('cc-selected');

  // Add event listener to the quantity input field
  quantityInput?.addEventListener('input', () => {
    updatePrice();
    choosePlan();
  });

  function choosePlan() {
    if (!quantityInput) return;

    const inputValue = parseInt(quantityInput.value);

    if (isNaN(inputValue)) return;

    if (inputValue <= 15) {
      if (radioEasy && radioPro) {
        radioEasy.checked = true;
        radioPro.checked = false;
      }
      easyRadioInputDiv?.classList.add('w--redirected-checked');
      proRadioInputDiv?.classList.remove('w--redirected-checked');
      easyParentElement?.classList.add('cc-selected');
      proParentElement?.classList.remove('cc-selected');
      easyLabelElement?.classList.add('cc-selected');
      proLabelElement?.classList.remove('cc-selected');
    } else if (inputValue > 15) {
      if (radioEasy && radioPro) {
        radioEasy.checked = false;
        radioPro.checked = true;
      }
      proRadioInputDiv?.classList.add('w--redirected-checked');
      easyRadioInputDiv?.classList.remove('w--redirected-checked');
      proParentElement?.classList.add('cc-selected');
      easyParentElement?.classList.remove('cc-selected');
      proLabelElement?.classList.add('cc-selected');
      easyLabelElement?.classList.remove('cc-selected');
    }
  }

  // Function to update the price based on the quantity
  function updatePrice() {
    if (!quantityInput || !proPriceElement || !easyPriceElement) return;

    // Get the quantity value entered by the user
    const quantity = parseInt(quantityInput.value);

    // Set the default price to 0
    let proPrice: number | string = 119;
    let easyPrice: number | string = 8;

    if (quantity <= 0 || quantity > 15 || isNaN(quantity)) {
      easyPrice = '-';
    } else {
      easyPrice = quantity * 8;
    }

    // Calculate the price based on the quantity range
    if (quantity <= 20) {
      proPrice = 119;
    } else if (quantity >= 21 && quantity <= 50) {
      proPrice = 179;
    } else if (quantity >= 51 && quantity <= 100) {
      proPrice = 239;
    } else if (quantity >= 101 && quantity <= 200) {
      proPrice = 299;
    } else if (quantity >= 201 && quantity <= 500) {
      proPrice = 479;
    } else if (quantity > 500) {
      proPrice = 'Pyydä tarjous!';
    }

    // Update the text element with the calculated price
    proPriceElement.textContent = typeof proPrice === 'number' ? `${proPrice}€/kk` : proPrice;
    easyPriceElement.textContent = typeof easyPrice === 'number' ? `${easyPrice}€/kk` : easyPrice;
  }

  if (orderForm) {
    // Function to handle form submission
    async function handleSubmit(event: Event) {
      event.preventDefault(); // Prevent the form from submitting normally

      // Get the form data
      const formData = new FormData(orderForm);

      try {
        // Send the form data to your backend API
        const response = await fetch(
          'https://navisec-pipedrive-orderform-api.myynti-390.workers.dev/',
          {
            method: 'POST',
            body: formData,
          }
        );

        // Check if the request was successful
        if (response.ok) {
          // Redirect the user to the desired page
          window.location.href = '/kiitos';
        } else {
          // Handle the error case
          console.error('Form submission failed');
        }
      } catch (error) {
        console.error('An error occurred:', error);
      }
    }
    orderForm.addEventListener('submit', handleSubmit);
  }
});
